import { useTypedSelector } from '@/hooks/useTypedSelector';
import {
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Layout, theme } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { Messages } from '../../providers/LocaleProvider/LocaleProvider.interfaces';
import { pages } from '../../routes/Routes.constants';
import styles from './Header.module.scss';

type Props = {
  name?: string;
  setCollapsed: (collapsed: boolean) => void;
  collapsed: boolean;
  handleLogout: () => void;
  setDrawerVisible: (visible: boolean) => void;
};

export const Header: FC<Props> = ({
  setCollapsed,
  collapsed,
  handleLogout,
  name,
  setDrawerVisible,
}) => {
  const { Header } = Layout;
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const location = useLocation();

  const isMobile = useTypedSelector((state) => state.common.isMobile);

  // Определяем название страницы по текущему пути
  const currentPageName = Object.values(pages).find((page) => {
    const isExactMatch = page.path === location.pathname;
    const isSupportChatSubPath = location.pathname.startsWith('/support-chat/');
    return (
      isExactMatch || (page.path === '/support-chat' && isSupportChatSubPath)
    );
  });

  const pageTitle = currentPageName ? currentPageName.label : '';

  return (
    <Header
      className={styles.header}
      style={{ padding: 0, background: colorBgContainer }}
    >
      {isMobile ? (
        <Button
          icon={<MenuOutlined />}
          type="text"
          style={{ marginLeft: 15, color: '#252525' }}
          onClick={() => setDrawerVisible(true)}
        />
      ) : (
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={{
            fontSize: '16px',
            width: 64,
            height: 64,
          }}
        />
      )}

      <div className={styles.pageTitle}>{pageTitle}</div>

      {!isMobile && (
        <div className={styles.name}>
          <UserOutlined />
          <span>{name}</span>
        </div>
      )}

      <Button
        className={styles.logout}
        type="default"
        onClick={handleLogout}
        style={{
          fontSize: '16px',
          width: 64,
        }}
      >
        <FormattedMessage id={Messages.LOGOUT} />
      </Button>
    </Header>
  );
};
